const search = [
    {id: 1, title: "StockIT", category: "Project" },
    {id: 2, title: "TakeNote", category: "Project" },
    {id: 3, title: "TaRct", category: "Project" },
    {id: 4, title: "To Do", category: "Project" },
    {id: 5, title: "ArchiTect", category: "Project" },
    {id: 6, title: "WeatherLy", category: "Project" },
    {id: 7, title: "Typing Test", category:"@JaneCooper" },
    {id: 8, title: "Artisan", category:  "@ArieneMcCoy" },
    {id: 9, title: "BBlocks", category: "@TheresaWebb" },
    {id: 10,title: "ZzShoes", category: "@RalphEdwards" },
    {id: 11,title: "SearchEngine", category: "@Raplhie" },
    {id: 12, title: "Alimage" , category: "Project"}
      
];
export default search